










import Component, { mixins } from 'vue-class-component';
import UrlMixin from '../../../mixins/url';

import Item from '@/components/Molecules/Breadcrumbs/Item.vue';

@Component({
  components: {
    Item,
  },
})
export default class Hikari extends mixins(UrlMixin) {}
